import { Component, Input } from '@angular/core';

/** Eine einzelne Aussage der Kopf-Hinweise. */
export interface StatusStatement {
  ok: boolean;
  text: string;
}

/**
 * Rendert die Kopf-Hinweise (headerTextShort / headerTextLong) als Statuszeilen.
 *
 * Vorher war der ganze Satz rot bzw. grün gefärbt - das wirkte unruhig und
 * unprofessionell. Jetzt trägt ausschliesslich das Symbol die Aussage (rotes
 * Ausrufezeichen bzw. grüner Haken), der Text ist überall gleich gesetzt und
 * die Zeilen stehen eng untereinander auf einer Linie.
 *
 * WICHTIG: Ein Feld kann MEHRERE Aussagen mit unterschiedlicher Einstufung
 * enthalten - im RE-Reiter etwa "Abweichende Preisdaten" (rot) zusammen mit
 * "Auftragsbestätigung wurde akzeptiert!" und "Wareneingang wurde gebucht!"
 * (beide grün) in einem einzigen String. Deshalb wird je <span> eine eigene
 * Zeile mit eigener Einstufung erzeugt.
 *
 * Die Einstufung stammt aus dem vom Server gelieferten "color:red"/"color:green" -
 * am Backend ändert sich nichts, der Wortlaut bleibt unverändert.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'status-line',
  templateUrl: './status-line.component.html',
  styleUrls: ['./status-line.component.css'],
})
export class StatusLineComponent {
  @Input() html = '';

  get statements(): StatusStatement[] {
    const source = this.html || '';
    const statements: StatusStatement[] = [];
    const spanPattern = /<span([^>]*)>([\s\S]*?)<\/span>/gi;
    let match: RegExpExecArray | null;
    while ((match = spanPattern.exec(source)) !== null) {
      const text = this.toPlainText(match[2]);
      if (text) {
        statements.push({ ok: this.isGreen(match[1]), text });
      }
    }
    if (statements.length === 0) {
      // Kein <span> vorhanden: den gesamten Text als eine Aussage behandeln.
      const text = this.toPlainText(source);
      if (text) {
        statements.push({ ok: this.isGreen(source), text });
      }
    }
    return statements;
  }

  private isGreen(value: string): boolean {
    return (value || '').toLowerCase().replace(/\s+/g, '').includes('color:green');
  }

  private toPlainText(value: string): string {
    return (value || '')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<[^>]+>/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
